export const copyToClipboard = async (val: string) => {
    return await navigator.clipboard.writeText(val);
};

export function shareAvailable(): boolean {
    return "share" in navigator;
}
